import styled from 'styled-components';
import { colors } from 'globalStyles';

export const ContentWrapper = styled.div`
  padding-top: 34px;
  width: 300px;

  > svg {
    fill: ${colors.RED};
  }

  > h1 {
    color: ${colors.RED};
    font-size: 36px;
    line-height: 44px;
    margin: 0;
    font-family: poppins, sans-serif;
  }
  > a {
    > button {
      font-size: 14px;
    }
    margin: 25px auto 0;
    width: 150px;
    display: block
  }
`;

export const Text = styled.p`
  font-size: 16px;
  color: ${colors.BODY};
  margin: 10px 0 0;
`;

// Inline (not a direct child of ContentWrapper), so it deliberately escapes the
// `> a` block/150px-wide rule above — that rule styles the old full-width CTA
// button, which would truncate an inline sentence fragment.
export const ContactLink = styled.a`
  color: ${colors.MAIN_COLOR};
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`;
